/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationSendStatusDto } from './notification-send-status-dto';


export interface UserDtoNotificationsInner { 
    id: string;
    type: string;
    createdAt: string;
    readStatus: UserDtoNotificationsInner.ReadStatusEnum;
    sendStatuses: Array<NotificationSendStatusDto>;
}
export namespace UserDtoNotificationsInner {
    export const ReadStatusEnum = {
        unread: 'unread',
        read: 'read'
    } as const;
    export type ReadStatusEnum = typeof ReadStatusEnum[keyof typeof ReadStatusEnum];
}


